import React from 'react'
import PropTypes from 'prop-types'
import { FieldArray, Field } from 'redux-form'
import { serializeOptions } from 'utils'
import { Select } from 'lp-components'
import { startCase } from 'lodash'

const propTypes = {
  disciplines: PropTypes.array.isRequired,
  prefix: PropTypes.string,
}

const defaultProps = {
  prefix: '',
}

function SubDisciplineTagInput({ input: { value }, onClick, disciplineName }) {
  if (value.disciplineName !== disciplineName) return null
  return (
    <button type="button" onClick={onClick}>
      {value.displayName}
      <br />
      <span>{startCase(value.tag)}</span>
    </button>
  )
}

function SubDisciplineFields({ fields, disciplineName }) {
  return (
    <ul className="tags">
      <li />
      {fields.map((field, i) => (
        <li key={i}>
          <Field
            name={field}
            disciplineName={disciplineName}
            component={SubDisciplineTagInput}
            onClick={() => fields.remove(i)}
          />
        </li>
      ))}
    </ul>
  )
}

function DisciplineBlock({
  fields,
  disciplineDisplayName,
  disciplineName,
  subDisciplines,
  prefix,
}) {
  const selectName = `${prefix ? prefix + '.' : ''}select-${disciplineName}`
  return (
    <div className="col-2">
      <Select
        label={disciplineDisplayName}
        placeholder="Select"
        input={{
          name: selectName,
          value: '',
          onChange: (e) => {
            const subDisciplineId = e.target.value
            const subDiscipline = subDisciplines.find(
              ({ id }) => id == subDisciplineId
            )
            if (!subDiscipline) return
            const existing = (fields.getAll() || []).some(
              (item) => item && item.subDisciplineId == subDiscipline.id
            )
            if (existing) return
            fields.push({
              subDisciplineId: subDiscipline.id,
              displayName: subDiscipline.displayName,
              disciplineName,
            })
          },
        }}
        meta={{}}
        options={serializeOptions(subDisciplines)}
      />
      <SubDisciplineFields fields={fields} disciplineName={disciplineName} />
    </div>
  )
}

function RequestedDisciplinesForm({ disciplines, prefix = '' }) {
  return (
    <div>
      <div className="row fields-with-tags">
        {disciplines.map(
          (
            {
              displayName: disciplineDisplayName,
              name: disciplineName,
              subDisciplines,
            },
            i
          ) => (
            <FieldArray
              key={i}
              name={`${prefix ? prefix + '.' : ''}subDisciplines`}
              component={DisciplineBlock}
              props={{
                disciplineDisplayName,
                disciplineName,
                subDisciplines,
                prefix,
              }}
            />
          )
        )}
      </div>
    </div>
  )
}

RequestedDisciplinesForm.propTypes = propTypes

RequestedDisciplinesForm.defaultProps = defaultProps

export default RequestedDisciplinesForm
